module.exports = function (context, property) {
  return context[property];
};
